import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    width: '722px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'left'
  }
}));
